<template>
  <Splitpanes @resize="paneResize" :horizontal="paneHorizontal">
    <Pane :min-size="firstColumnMinSize"
          :max-size="firstColumnMaxSize"
          :size="firstColumnSize">
      <slot name="first-column">
      </slot>
    </Pane>
    <Pane min-size="50" :size="100 - firstColumnSize">
      <slot name="second-column">
      </slot>
    </Pane>
  </Splitpanes>
</template>

<script>
import {Pane, Splitpanes} from "splitpanes";

export default {
  name: "ResizableColumns",
  components: {Splitpanes, Pane},
  props: {
    identifier: {
      type: String,
      required: true
    },
    firstColumnMinSize: {
      type: Number,
      required: false,
      default: 25
    },
    firstColumnMaxSize: {
      type: Number,
      required: false,
      default: 50
    },
    firstColumnDefaultSize: {
      type: Number,
      required: false,
      default: 35
    },
  },
  data() {
    return {
      firstColumnSize: this.firstColumnDefaultSize,
      paneHorizontal: false,
    }
  },
  computed: {
    localStorageIdentifier() {
      return this.identifier + '-resizable-columns';
    }
  },
  mounted() {
    const panelInitialSize = localStorage.getItem(this.localStorageIdentifier);
    if (panelInitialSize) {
      this.firstColumnSize = panelInitialSize;
    }
    window.addEventListener("resize", this.handleWindowSizeChange);
    this.handleWindowSizeChange();
  },
  unmounted() {
    window.removeEventListener("resize", this.handleWindowSizeChange);
  },
  methods: {
    paneResize(data) {
      localStorage.setItem(this.localStorageIdentifier, data[0].size);
    },
    handleWindowSizeChange() {
      const pageWidth = document.getElementById('app').offsetWidth;
      this.paneHorizontal = (pageWidth <= 1390);
    }
  }
}
</script>

<style lang="scss">
.splitpanes--horizontal > .splitpanes__splitter {
  display: none;
}
</style>